module.exports = __webpack_public_path__ + "img/grid_1.7b2f369d.svg";